import { Button, Flex, Popup } from '@approvalmax/ui/src/components';
import { useAtomValue } from 'jotai';
import { memo, useCallback } from 'react';
import { useNetSuiteCreateMatching } from 'shared/hooks/(matchings)';

import { netSuiteSourceMatchingLineState, netSuiteTargetMatchingLineState } from '../../NetSuiteMatchingPopup.states';
import { PurchaseOrdersList } from '../PurchaseOrdersList/PurchaseOrdersList';
import { SourceLineInformation } from '../SourceLineInformation/SourceLineInformation';
import { messages } from './Content.messages';
import { ContentProps } from './Content.types';

export const Content = memo((props: ContentProps) => {
    const { request, currencyISOCode, isRequestForm, saveMatching, onClose } = props;

    const targetLine = useAtomValue(netSuiteTargetMatchingLineState);

    const sourceLine = useAtomValue(netSuiteSourceMatchingLineState);

    const { isLoadingCreateMatching } = useNetSuiteCreateMatching(sourceLine?.lineType);

    const onSave = useCallback(() => {
        saveMatching(onClose);
    }, [saveMatching, onClose]);

    return (
        <>
            <Popup.Header
                title={messages.matchLines}
                actionsSize='xsmall'
                actions={
                    <Button
                        title={messages.match}
                        color='blue80'
                        size='small'
                        onClick={onSave}
                        disabled={!targetLine}
                        progress={isLoadingCreateMatching}
                    >
                        {messages.match}
                    </Button>
                }
            />

            <Popup.Body spacing='20 40'>
                <Flex direction='column' height='100%'>
                    <SourceLineInformation request={request} />

                    <PurchaseOrdersList
                        request={request}
                        currencyISOCode={currencyISOCode}
                        isRequestForm={isRequestForm}
                    />
                </Flex>
            </Popup.Body>
        </>
    );
});

Content.displayName = 'Content';
